<template>
  <div class="navbar">
    <div class="block"></div>
    <div class="layout-logo l">
      <img :src="logo" />
    </div>
    <el-menu :default-active="active" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item  v-for="item in MenuItem" :index="item.link" :key="item.link">
          {{item.title}}
        </el-menu-item>
    </el-menu>
    <div class="block"></div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      logo: require('@/assets/pcimages/LOGO1.png'),
      value: false,
      MenuItem: [
        {
          name: '1',
          link: '/dashboard',
          title: '首页'
        },
        {
          name: '2',
          link: '/successfulCases',
          title: '成功案例'
        },
        {
          name: '3',
          link: '/technicalService',
          title: '技术服务'
        },
        {
          name: '4',
          link: 'https://ime.nmgoyun.com/',
          title: '下载'
        },
        {
          name: '5',
          link: '/aboutUs',
          title: '关于我们'
        },
        {
          name: '6',
          link: '/joinUs',
          title: '加入我们'
        },
        // {
        //   name: '7',
        //   link: 'https://chat.nmgoyun.com/',
        //   title: '奥云大模型'
        // },
        {
          name: '8',
          link: 'https://ai.nmgoyun.com/',
          title: '奥云AI'
        },
        {
          name: '9',
          link: '/mnHome',
          title: '蒙古文版'
        }
      ],
      active: ''
    }
  },
  mounted () {
    this.active = this.$route.path
  },
  methods: {
    handleSelect (val) {
      if (val.startsWith('/')) {
        this.$router.replace({path: val})
      } else {
        window.open(val, '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  overflow: hidden;
  position: relative;
  background: #fff;
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .layout-logo {
    float: left;
  }

  .block{
    flex: 0 0 px2rem(120);
  }
  .el-menu.el-menu--horizontal{
    align-self: flex-end;
    margin-bottom: 10px;
    border:none;
    &>.el-menu-item{
      color:black;
      line-height: 60px;
      font-size: 18px;
      font-family: 'PingFangSC-Light', 'PingFang SC';
    }
  }
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Navbar.vue